import React, { useState } from "react";
import SignatureFormatter from "./components/SignatureFormatter";
import "./style.css";

const SIGNATURE_SELECTOR = ".wrapper-table > table";

const userData = {
  firstname: "Corinne",
  lastname: "ROY",
  job: "CONSEILLÈRE EN GESTION DE PATRIMOINE",
  phone: "+33 (0)6 07 99 10 14",
};

const inputFields = [
  { label: "Prénom", name: "firstname" },
  { label: "Nom", name: "lastname" },
  { label: "Poste", name: "job" },
  { label: "Mobile", name: "phone" },
];

const setImportantStyles = (element, styles) => {
  Object.entries(styles).forEach(([property, value]) => {
    element.style.setProperty(property, value, "important");
  });
};

const replaceParagraphs = root => {
  root.querySelectorAll("p").forEach(paragraph => {
    const span = document.createElement("span");

    Array.from(paragraph.attributes).forEach(attribute => {
      span.setAttribute(attribute.name, attribute.value);
    });

    span.innerHTML = paragraph.innerHTML;
    span.style.setProperty("display", "block", "important");
    span.style.setProperty("padding", "0", "important");
    span.style.setProperty(
      "margin",
      paragraph.style.margin || "0",
      "important"
    );

    paragraph.replaceWith(span);
  });
};

const prepareSignatureForClipboard = signature => {
  const signatureClone = signature.cloneNode(true);

  replaceParagraphs(signatureClone);

  [signatureClone, ...signatureClone.querySelectorAll("table")].forEach(table => {
    table.setAttribute("align", "left");
    setImportantStyles(table, {
      border: "0",
      "border-collapse": "collapse",
      "border-spacing": "0",
      "line-height": "normal",
      margin: "0",
      "margin-left": "0",
      "margin-right": "0",
      padding: "0",
      "mso-table-lspace": "0pt",
      "mso-table-rspace": "0pt",
    });
  });

  setImportantStyles(signatureClone, { width: "600px" });

  signatureClone.querySelectorAll("td").forEach(cell => {
    const padding = cell.style.padding || "0";

    setImportantStyles(cell, {
      border: "0",
      "border-bottom": "0",
      "border-left": "0",
      "border-right": "0",
      "border-top": "0",
      "mso-line-height-rule": "exactly",
      padding,
    });
  });

  signatureClone.querySelectorAll("img").forEach(image => {
    setImportantStyles(image, {
      border: "0",
      display: "block",
      outline: "0",
      "text-decoration": "none",
    });
  });

  return signatureClone.outerHTML;
};

export default function App() {
  const [user, setUser] = useState(userData);

  const userInfoChange = event => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  const copyWithSelection = html => {
    const container = document.createElement("div");
    container.innerHTML = html;
    container.style.cssText =
      "position:fixed;left:0;top:0;width:600px;opacity:0;pointer-events:none;";
    document.body.appendChild(container);

    const range = document.createRange();
    range.selectNode(container);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    document.body.removeChild(container);
  };

  const copyToClipboard = async () => {
    const signatureToCopy = document.querySelector(SIGNATURE_SELECTOR);

    if (!signatureToCopy) return;

    const signatureHtml = `
      <div style="margin:0!important;margin-left:0!important;margin-right:0!important;padding:0!important;text-align:left!important;width:600px!important;">
        ${prepareSignatureForClipboard(signatureToCopy)}
      </div>
    `;

    if (navigator.clipboard && window.ClipboardItem) {
      try {
        await navigator.clipboard.write([
          new window.ClipboardItem({
            "text/html": new Blob([signatureHtml], { type: "text/html" }),
            "text/plain": new Blob([signatureToCopy.textContent], {
              type: "text/plain",
            }),
          }),
        ]);

        return;
      } catch (error) {
        copyWithSelection(signatureHtml);
        return;
      }
    }

    copyWithSelection(signatureHtml);
  };

  function responseCopy() {
    const button = document.querySelector("button");
    button.classList.add("copied");
    setTimeout(() => {
      button.classList.remove("copied");
    }, 2000);
  }

  return (
    <div className="appWrapper">
      <section className="formulaire">
        <div className="signaturePreview">
          <SignatureFormatter user={user} />
        </div>

        <div className="rightPart">
          <h1 className="title">Signature Generator</h1>
          <h2 className="title">CR Concept Patrimoine</h2>

          <p className="inputLabel">Informations</p>

          {inputFields.map(field => (
            <div className="inputWrapper" key={field.name}>
              <input
                name={field.name}
                onChange={userInfoChange}
                placeholder={field.label}
                value={user[field.name]}
              />
            </div>
          ))}

          <button
            className="copyButton"
            onClick={async () => {
              await copyToClipboard();
              responseCopy();
            }}
          >
            <p className="btnCopy"></p>
          </button>
        </div>
      </section>
    </div>
  );
}
